// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Sign/Register/Register.css */


.register-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh;
    background-color: white;
    border-radius: 10px;
    padding: 2rem;
}

.register-headi {
    color: #364C63;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.register-left {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
}

.register-left form {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: auto;
}

.register-left label {
    font-size: 1rem;
    color: #364C63;
    margin-bottom: 0.25rem;
    /* text-align: left; */
}

.register-left input {
    padding: 0.25rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 1rem;
    outline: none;
}

.register-left input:focus {
    border-color: #EF6F53;
}

.register-left select{
    font-size: 1rem;
    width: 100%; 
    background-color: white;
    color: #323232;
    border: 1px solid #ccc;
    border-radius: 10px;
    text-align: center;
    padding: 0.25rem;
}


.register-left button {
    background-color: #EF6F53;
    color: white;
    border: none;
    width: 30%;
    margin: auto;
    margin-top: 1rem;
    padding: 0.25rem;
    font-size: 1rem;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.register-left button:hover {
    background-color: #d15846;
}

.logis{
    display: flex;
    margin: auto;
}

.head2 {
    color: #364C63;
    text-align: center;
    font-size: 0.9rem;
    margin-top: 0.75rem;
    margin-right: 0.5rem;
}

.login-link {
    display: inline-block;
    margin-top: 0.5rem;
    color: #EF6F53;
    font-weight: bold;
    text-decoration: none;
}

.login-link:hover {
    text-decoration: underline;
}



.register-right {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.register-icon {
    width: 80%;
    max-width: 25rem;
    border-radius: 5px;
    margin-left: 30%;
}

.pending-approval{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 2rem;
}

.pending-heading{
    color: #EF6F53;
    font-size: 1.2rem;
    margin-bottom: 1rem;
}

.pending-text{
    color: #364C63;
    font-size: 1rem;
}

.alert {
    padding: 12px;
    margin-bottom: 20px;
    border-radius: 4px;
    text-align: center;
}

.alert-error {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #ffcdd2;
}

.alert-success {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
}

.button-registering {
    opacity: 0.7;
    cursor: not-allowed;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

/* Add loading animation */
.button-registering::after {
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: 10px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }   
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/Register/Register.css"],"names":[],"mappings":"AAAA,qDAAqD;;;AAGrD;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;;;AAIA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* src/components/routes/Sign/Register/Register.css */\n\n\n.register-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 75vh;\n    background-color: white;\n    border-radius: 10px;\n    padding: 2rem;\n}\n\n.register-headi {\n    color: #364C63;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n}\n\n.register-left {\n    width: 30%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 1rem;\n    background-color: white;\n    border-radius: 10px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);\n}\n\n.register-left form {\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    margin: auto;\n}\n\n.register-left label {\n    font-size: 1rem;\n    color: #364C63;\n    margin-bottom: 0.25rem;\n    /* text-align: left; */\n}\n\n.register-left input {\n    padding: 0.25rem;\n    font-size: 1rem;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    margin-bottom: 1rem;\n    outline: none;\n}\n\n.register-left input:focus {\n    border-color: #EF6F53;\n}\n\n.register-left select{\n    font-size: 1rem;\n    width: 100%; \n    background-color: white;\n    color: #323232;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    text-align: center;\n    padding: 0.25rem;\n}\n\n\n.register-left button {\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    width: 30%;\n    margin: auto;\n    margin-top: 1rem;\n    padding: 0.25rem;\n    font-size: 1rem;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.register-left button:hover {\n    background-color: #d15846;\n}\n\n.logis{\n    display: flex;\n    margin: auto;\n}\n\n.head2 {\n    color: #364C63;\n    text-align: center;\n    font-size: 0.9rem;\n    margin-top: 0.75rem;\n    margin-right: 0.5rem;\n}\n\n.login-link {\n    display: inline-block;\n    margin-top: 0.5rem;\n    color: #EF6F53;\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.login-link:hover {\n    text-decoration: underline;\n}\n\n\n\n.register-right {\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.register-icon {\n    width: 80%;\n    max-width: 25rem;\n    border-radius: 5px;\n    margin-left: 30%;\n}\n\n.pending-approval{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    margin-top: 2rem;\n}\n\n.pending-heading{\n    color: #EF6F53;\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n}\n\n.pending-text{\n    color: #364C63;\n    font-size: 1rem;\n}\n\n.alert {\n    padding: 12px;\n    margin-bottom: 20px;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.alert-error {\n    background-color: #ffebee;\n    color: #c62828;\n    border: 1px solid #ffcdd2;\n}\n\n.alert-success {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n    border: 1px solid #c8e6c9;\n}\n\n.button-registering {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\nbutton:disabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Add loading animation */\n.button-registering::after {\n    content: '';\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    margin-left: 10px;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n    border-top-color: transparent;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
